import { Component, Vue } from "vue-property-decorator";
// Components
import { GeneralSettings } from "@/components/index";

@Component({
  components: {
    GeneralSettings,
  },
})
export default class Settings extends Vue {
  linksBackOffice = [
    {
      name: "🏭 Entrepôts",
      path: "/parametres/entrepots",
      description: "Ajouter, modifier ou supprimer des entrepôts",
    },
    {
      name: "🏙️ Clients",
      path: "/parametres/clients",
      description:
        "Ajouter le logo, intégrer les Steps00 ou désactiver des pages",
    },
    {
      name: "🧷 Entrepôt-Client",
      path: "/parametres/entrepot-client",
      description:
        "Assigner un ou plusieurs entrepôts à un ou plusieurs clients",
    },
    {
      name: "👨🏻‍💻 Utilisateurs",
      path: "/parametres/utilisateurs",
      description:
        "Consulter les utilisateurs de Log One et modifier leurs langues",
    },
    {
      name: "📊 Statistiques",
      path: "/parametres/statistiques",
      description:
        "Consulter les statistiques d'utilisation de l'application Log One",
    },
    {
      name: "🧐 Retours utilisateurs",
      path: "/parametres/retours-utilisateurs",
      description: "Consulter les feedbacks des utilisateurs de Log One",
    },
    {
      name: "💫 Changer de clients",
      path: "/parametres/change-client",
      description: "Consulter toutes les données d'un autre déposant",
    },
  ];
}
